<template>
  <form @submit.prevent>
    <CModal
        :title.sync="title"
        color="info"
        :closeOnBackdrop ="false"
        :show.sync="show">
        <CRow>
          <CCol>
          <label class="mb-3"> <i  > List all class template except <b>"single class" </b>  </i>  </label>
           <model-select v-model="form.class_template_id" :options="filtered_listclass"></model-select>
          </CCol> 
          </CRow>
        <template #footer>
        <CButton @click="show = false" color="danger">Cancel</CButton>
        <CButton  v-if="mode === 'edit'" type="submit" v-on:click.prevent="add_class(form.id, form.class_template_id)"  variant="outline" color="info">Add</CButton>
      </template>
      <!-- <pre>{{ $data  }}</pre> -->
    </CModal>
  </form>

</template>

<script>
import axios from 'axios'
import EventBus from '@/eventBus';
import { ModelSelect } from "vue-search-select";
import classbatch from '@/services/batch'
import classtemplate from '@/services/class_template'

export default {
name: 'assignmodal',
components: { ModelSelect},
  data () {
    return {
      show: false,
      title: 'Default Title',
      mode: '',
      form:{
        id:'',
        class_template_id:'',
      },
      listclass:[],
      filtered_listclass:[],
      
    }
  },
  mounted (){
     this.load()

      EventBus.$on('PAGE_UPDATE', (data) => {
      if(data){
          this.load();
      }
    });
   },
   computed: {
        // filterArray: function() {
        //     var result =  this.listclass.filter((item) =>
        //         item.class_template_id.typ(this.search)
        //     );
           
        //     return result;
        // }
    },
  created () {
    var self = this;
    EventBus.$on('OPEN_MODAL_ADD_CLASS', (params) => {
      if(params.data){
        classbatch.getBatchbyID(params.data)
        .then(res => {
          self.show = true;
          self.title = params.title;
          self.mode = params.mode;
          const ids = res.data.list_class_template.map(item => item.class_template.id);
          self.filtered_listclass = self.listclass.filter(item => !ids.includes(item.value))
          }).catch ((err) => {
        var params = {title: 'Error', mode:'danger', data:err.response.data.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
        })
      }else{
        self.show = true;
        self.title = params.title;
        self.mode = params.mode;
        self.form.id = "";
        self.form.class_template_id  = "";
      }
    });
    this.form.id = this.$route.query.Pud
  },
   mounted (){
     this.loadData()
   },
  methods: {
    open () {
      this.show = true;
    },
    close () {
      this.show = false;
    },
    
    loadData() {
      classtemplate.getTemplate()
        .then(res => {
          for (let i=0; i <= res.data.length-1; i++){
            //alert
            this.listclass.push({text: res.data[i].name, value:res.data[i].id})
            
          }
        })

    },
    add_class(id,class_template_id){
      this.show = false;
      if(confirm("Add class to this curriculum ?")){
        var param = {
            class_template_id: class_template_id,
          }
          classbatch.add_class(id,param)
          .then(res => {
            //this.load()
            EventBus.$emit('PAGE_UPDATE', true)
            var params = {title: 'Success', mode:'success', data:res.message}
            EventBus.$emit('OPEN_MODAL_ALERT', params)
          }).catch ((err) => {
            var params = {title: 'Error', mode:'danger', data:err.response.data.message}
            EventBus.$emit('OPEN_MODAL_ALERT', params)
          })
        }
    },
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>